// Pure functions, no Angular DI — same convention as offline-feature-gate.ts.
//
// The student's chosen quality for saved videos, set once on the downloads page and used by
// every lesson save, so the Save button stays one tap. Kept per device in localStorage: it is a
// device decision (space, data allowance), and localStorage is already per school, since each
// school is its own subdomain.

export interface VideoQualityOption {
  maxHeight: number;
  label: string;
}

export const VIDEO_QUALITY_OPTIONS: VideoQualityOption[] = [
  { maxHeight: 360, label: '360p — smallest files' },
  { maxHeight: 480, label: '480p — smaller files' },
  { maxHeight: 720, label: '720p — recommended' },
  { maxHeight: 1080, label: '1080p — largest files' },
];

export const DEFAULT_VIDEO_QUALITY = 720;
const STORAGE_KEY = 'impata.offline.videoQuality';

export function getVideoQuality(): number {
  try {
    const stored = Number(localStorage.getItem(STORAGE_KEY));
    if (VIDEO_QUALITY_OPTIONS.some((o) => o.maxHeight === stored)) return stored;
  } catch {
    /* private mode — fall through to the default */
  }
  return DEFAULT_VIDEO_QUALITY;
}

export function setVideoQuality(maxHeight: number): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(maxHeight));
  } catch {
    /* private mode — the choice simply does not persist */
  }
}
